/* THE DOGS · MAJESTUOSO URL test · product 10451869794604 only.
 * Real variants and native Shopify automatic discounts; no client-side price overrides.
 */
(() => {
  'use strict';
  const TAG = 'td-majestuoso-duo';
  const PRODUCT_ID = '10451869794604';
  if (customElements.get(TAG)) return;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const sameOptions = (a, b) => a.length === b.length && a.every((value, index) => String(value) === String(b[index]));

  class MajestuosoDuo extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.dataset.productId !== PRODUCT_ID) return;
      const configNode = this.querySelector('[data-td-md-config]');
      if (!configNode) return;
      try {
        this.config = JSON.parse(configNode.textContent);
        if (String(this.config.productId) !== PRODUCT_ID) return;
        this.variants = this.config.variants;
        this.options = this.config.options;
        this.colorIndex = this.options.findIndex(option => /colou?r/.test(normalize(option.name)));
        this.sizeIndex = this.options.findIndex((option, index) => index !== this.colorIndex);
        // Unknown product structures retain the complete native variant dropdown.
        if (this.options.length !== 2 || this.colorIndex < 0 || this.sizeIndex < 0 || !this.variants.length) return;
        const initial = this.variants.find(variant => String(variant.id) === String(this.config.selectedVariantId)) || this.variants.find(variant => variant.available) || this.variants[0];
        this.state = { quantity: 1, first: initial.options.slice(), second: initial.options.slice(), secondColorTouched: false, secondSizeTouched: false };
        this.form = this.querySelector('form');
        this.ui = this.querySelector('[data-td-md-ui]');
        this.fallback = this.querySelector('[data-td-md-fallback]');
        this.variantSelect = this.form.querySelector('select[name="id"]');
        this.submitButton = this.querySelector('[data-td-md-submit]');
        this.submitLabel = this.querySelector('[data-td-md-submit-label]');
        this.errorNode = this.querySelector('[data-td-md-error]');
        this.statusNode = this.querySelector('[data-td-md-status]');
        this.shippingNode = this.querySelector('[data-td-md-shipping]');
        this.currency = this.config.currency || 'CLP';
        this.discountPercent = this.config.discountEnabled === true ? 20 : 0;
        this.busy = false;
        this.cartReviewRequired = false;
        this.cartRecoveryPending = false;
        this.pendingRequest = this.readPendingRequest();
        this.buildUI();
        this.onSubmitBound = this.onSubmit.bind(this);
        this.onChangeBound = this.onChange.bind(this);
        this.onClickBound = this.onClick.bind(this);
        this.onPageShowBound = this.onPageShow.bind(this);
        this.form.addEventListener('submit', this.onSubmitBound);
        this.ui.addEventListener('change', this.onChangeBound);
        this.ui.addEventListener('click', this.onClickBound);
        window.addEventListener('pageshow', this.onPageShowBound);
        this.render();
        this.ui.hidden = false;
        this.fallback.hidden = true;
        this.initialized = true;
        this.dataset.ready = 'true';
        if (this.pendingRequest) {
          this.requireCartReview('Estamos comprobando tu última selección con el carrito.');
          this.render();
          Promise.resolve().then(() => this.recoverAfterCartReview());
        }
      } catch (error) {
        console.warn('MAJESTUOSO selector: native purchase retained.', error);
        if (this.ui) this.ui.hidden = true;
        if (this.fallback) this.fallback.hidden = false;
        if (this.form && this.onSubmitBound) this.form.removeEventListener('submit', this.onSubmitBound);
        if (this.onPageShowBound) window.removeEventListener('pageshow', this.onPageShowBound);
      }
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.form.removeEventListener('submit', this.onSubmitBound);
      this.ui.removeEventListener('change', this.onChangeBound);
      this.ui.removeEventListener('click', this.onClickBound);
      window.removeEventListener('pageshow', this.onPageShowBound);
      if (this.cartRecoveryTimer) window.clearTimeout(this.cartRecoveryTimer);
      this.initialized = false;
    }

    node(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }

    money(cents) {
      return new Intl.NumberFormat('es-CL', { style: 'currency', currency: this.currency, maximumFractionDigits: this.currency === 'CLP' ? 0 : 2 }).format(Number(cents || 0) / 100);
    }

    variant(options) { return this.variants.find(item => sameOptions(item.options, options)) || null; }

    sizeLabel(value) {
      const match = String(value).match(/([234])\s*(?:cuerpos?|plazas?)/i);
      return match ? `${match[1]} cuerpos` : String(value);
    }

    sizeHint(value) {
      const label = this.sizeLabel(value);
      const presets = {
        '2 cuerpos': 'Para sofá de 2 personas · 70 × 150 cm',
        '3 cuerpos': 'Para sofá de 3 personas · 70 × 180 cm',
        '4 cuerpos': 'Para 4 cuerpos o 3 cuerpos XL · 70 × 210 cm'
      };
      return presets[label] || String(value);
    }

    makeOptions(piece, index, title, color) {
      const field = this.node('fieldset', 'td-md__field');
      const legend = this.node('legend', 'td-md__legend', title);
      const current = this.node('span', 'td-md__color-name');
      if (color) legend.append(' · ', current);
      field.append(legend);
      const list = this.node('div', color ? 'td-md__colors' : 'td-md__sizes');
      this.options[index].values.forEach(value => {
        const button = this.node('button', color ? 'td-md__color-button' : 'td-md__size-button');
        button.type = 'button';
        button.dataset.tdMdOption = '';
        button.dataset.piece = String(piece);
        button.dataset.optionIndex = String(index);
        button.dataset.optionValue = String(value);
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', `${piece === 0 ? 'Primer' : 'Segundo'} MAJESTUOSO: ${value}`);
        if (color) {
          // Only use real images belonging to the selected color, never an invented product.
          const sample = this.variants.find(variant => String(variant.options[index]) === String(value) && variant.image);
          if (sample) {
            const image = this.node('img');
            image.src = sample.image;
            image.alt = '';
            image.width = 80;
            image.height = 80;
            image.loading = piece === 0 ? 'eager' : 'lazy';
            image.decoding = 'async';
            button.append(image);
          } else {
            const swatch = this.node('span', 'td-md__color-swatch');
            const name = normalize(value);
            const tone = name.includes('oscuro') || name.includes('negro') ? '#555451' : name.includes('gris') ? '#b9b8b2' : name.includes('blanco') || name.includes('crema') ? '#eee9df' : '#b7a28c';
            swatch.style.setProperty('--td-md-swatch', tone);
            swatch.setAttribute('aria-hidden', 'true');
            button.append(swatch);
          }
          button.append(this.node('span', '', String(value)));
        } else button.textContent = this.sizeLabel(value);
        list.append(button);
      });
      field.append(list);
      return { field, legend, current };
    }

    buildUI() {
      this.ui.replaceChildren();
      this.sizeFirst = this.makeOptions(0, this.sizeIndex, 'Talla según tu sofá', false);
      this.sizeHintNode = this.node('p', 'td-md__hint');
      this.sizeFirst.field.append(this.sizeHintNode);
      this.ui.append(this.sizeFirst.field);

      this.colorFirst = this.makeOptions(0, this.colorIndex, 'Color', true);

      this.offers = this.node('fieldset', 'td-md__offers');
      this.offers.append(this.node('legend', 'td-md__legend', 'Elige tu opción'));
      this.offerNodes = {};
      [1, 2].forEach(quantity => {
        const label = this.node('label', `td-md__offer${quantity === 2 ? ' td-md__offer--duo' : ''}`);
        const top = this.node('span', 'td-md__offer-top');
        const radio = this.node('input');
        radio.type = 'radio';
        radio.name = `td-md-offer-${this.config.sectionId}`;
        radio.value = String(quantity);
        radio.dataset.tdMdQuantity = '';
        const name = this.node('span', 'td-md__offer-title', quantity === 1 ? '1 MAJESTUOSO' : 'Dúo · 2 unidades');
        const price = this.node('span', 'td-md__price');
        top.append(radio, name, price);
        label.append(top);
        const benefit = this.node('span', 'td-md__offer-benefit');
        const extra = this.node('span', 'td-md__offer-extra');
        if (quantity === 2) {
          label.append(this.node('span', 'td-md__offer-copy', 'Uno puesto, otro de recambio.'), benefit, extra);
        }
        this.offerNodes[quantity] = { label, radio, price, benefit, extra };
        this.offers.append(label);
      });
      this.ui.append(this.offers);

      this.duoColors = this.node('div', 'td-md__duo-colors');
      this.duoHelp = this.node('p', 'td-md__hint', 'Elige tus dos colores. Puedes repetir o combinarlos.');
      this.duoColors.append(this.duoHelp);
      this.colorDuoHome = this.node('div');
      this.colorDuoHome.append(this.colorFirst.field);
      this.duoColors.append(this.colorDuoHome);
      this.colorSecond = this.makeOptions(1, this.colorIndex, 'Color del segundo', true);
      this.duoColors.append(this.colorSecond.field);
      this.ui.append(this.duoColors);

      this.secondSize = this.node('details', 'td-md__second-size');
      this.secondSize.append(this.node('summary', '', 'Cambiar la talla del segundo'));
      this.sizeSecond = this.makeOptions(1, this.sizeIndex, 'Talla del segundo', false);
      this.secondSize.append(this.sizeSecond.field);
      this.sameSizeButton = this.node('button', 'td-md__reset-size', 'Usar la misma talla del primero');
      this.sameSizeButton.type = 'button';
      this.sameSizeButton.dataset.tdMdSameSize = '';
      this.secondSize.append(this.sameSizeButton);
      this.ui.append(this.secondSize);
      this.summaryNode = this.node('p', 'td-md__selection-summary');
      this.ruleNode = this.node('p', 'td-md__hint', 'En tallas distintas, el 20% se aplica a la de menor valor.');
      this.ui.append(this.summaryNode, this.ruleNode);
      this.cartReviewLink = this.node('a', 'td-md__cart-review', 'Revisar mi carrito');
      this.cartReviewLink.href = this.cartURL();
      this.cartReviewLink.hidden = true;
      this.errorNode.after(this.cartReviewLink);
    }

    onClick(event) {
      const option = event.target.closest('[data-td-md-option]');
      if (option && this.ui.contains(option) && !this.busy) {
        this.selectOption(Number(option.dataset.piece), Number(option.dataset.optionIndex), option.dataset.optionValue);
        return;
      }
      if (event.target.closest('[data-td-md-same-size]') && !this.busy) {
        this.state.secondSizeTouched = false;
        this.state.second[this.sizeIndex] = this.state.first[this.sizeIndex];
        this.clearError();
        this.render(true);
      }
    }

    onChange(event) {
      if (!event.target.matches('[data-td-md-quantity]') || this.busy) return;
      this.state.quantity = Number(event.target.value) === 2 ? 2 : 1;
      // Once both palettes are visible, each color is independent.
      if (this.state.quantity === 2) this.state.secondColorTouched = true;
      this.clearError();
      this.render(true);
      this.track('td_majestuoso_offer_changed', { quantity: this.state.quantity });
    }

    selectOption(piece, index, value) {
      if (this.busy || !this.options[index].values.some(option => String(option) === String(value))) return;
      if (piece === 0) {
        this.state.first[index] = value;
        if (index === this.sizeIndex && !this.state.secondSizeTouched) this.state.second[index] = value;
        if (index === this.colorIndex && !this.state.secondColorTouched) this.state.second[index] = value;
      } else {
        this.state.second[index] = value;
        if (index === this.sizeIndex) this.state.secondSizeTouched = true;
        if (index === this.colorIndex) this.state.secondColorTouched = true;
      }
      this.clearError();
      this.render(true);
      const variant = this.variant(piece === 0 ? this.state.first : this.state.second);
      if (piece === 0 && variant) {
        // The gallery and its original color thumbnails represent the first
        // MAJESTUOSO. The second color stays independent in its own palette.
        this.updateMedia(variant);
        this.updateURL(variant);
        this.dispatchEvent(new CustomEvent('td:majestuoso:primary-variant-change', {
          bubbles: true,
          detail: { productId: PRODUCT_ID, variantId: String(variant.id) }
        }));
      }
    }

    canSupply(variant, quantity) {
      if (!variant || !variant.available) return false;
      if (variant.inventoryManagement && variant.inventoryPolicy !== 'continue' && Number.isFinite(variant.inventoryQuantity)) {
        if (quantity > variant.inventoryQuantity) return false;
      }
      const rule = variant.quantityRule || {};
      const min = Number(rule.min || 1);
      const increment = Number(rule.increment || 1);
      return quantity >= min && (!rule.max || quantity <= Number(rule.max)) && (quantity - min) % increment === 0;
    }

    requestedItems() {
      const selections = [this.state.first];
      if (this.state.quantity === 2) selections.push(this.state.second);
      const items = new Map();
      for (const options of selections) {
        const variant = this.variant(options);
        if (!variant) return null;
        const id = String(variant.id);
        const item = items.get(id) || { id: variant.id, quantity: 0 };
        item.quantity++;
        items.set(id, item);
      }
      return Array.from(items.values());
    }

    selectionError(cart) {
      const items = this.requestedItems();
      if (!items) return 'Esta combinación no está disponible. Elige otra talla o color.';
      for (const item of items) {
        const existing = cart ? cart.items.filter(line => String(line.variant_id || line.id) === String(item.id)).reduce((sum, line) => sum + Number(line.quantity), 0) : 0;
        const variant = this.variants.find(value => String(value.id) === String(item.id));
        if (!this.canSupply(variant, item.quantity + existing)) {
          return existing ? 'Ya tienes unidades de esta variante en el carrito y no queda stock suficiente para agregar esta selección.' : 'No hay unidades suficientes para esta combinación. Puedes cambiar el color del segundo o elegir otra talla.';
        }
      }
      return '';
    }

    prices() {
      const first = this.variant(this.state.first);
      const second = this.variant(this.state.second);
      const single = first ? Number(first.price) : null;
      const discount = first && second ? Math.round(Math.min(first.price, second.price) * this.discountPercent / 100) : 0;
      const duo = first && second ? first.price + second.price - discount : null;
      return { single, duo, discount, total: this.state.quantity === 1 ? single : duo };
    }

    render(announce = false) {
      const duo = this.state.quantity === 2;
      const first = this.variant(this.state.first);
      const second = this.variant(this.state.second);
      const prices = this.prices();
      this.sizeHintNode.textContent = this.sizeHint(this.state.first[this.sizeIndex]);
      this.colorFirst.legend.replaceChildren(document.createTextNode(duo ? 'Color del primero · ' : 'Color · '), this.colorFirst.current);
      this.colorFirst.current.textContent = this.state.first[this.colorIndex];
      this.colorSecond.current.textContent = this.state.second[this.colorIndex];
      this.duoHelp.hidden = !duo;
      this.colorSecond.field.hidden = !duo;
      this.secondSize.hidden = !duo;
      this.summaryNode.hidden = !duo;
      this.ruleNode.hidden = !duo || !this.discountPercent || !first || !second || first.price === second.price;
      const summary = `1.º ${this.sizeLabel(this.state.first[this.sizeIndex])} · ${this.state.first[this.colorIndex]} / 2.º ${this.sizeLabel(this.state.second[this.sizeIndex])} · ${this.state.second[this.colorIndex]}`;
      this.summaryNode.textContent = summary;

      this.ui.querySelectorAll('[data-td-md-option]').forEach(button => {
        const piece = Number(button.dataset.piece);
        const index = Number(button.dataset.optionIndex);
        const value = button.dataset.optionValue;
        const selected = piece === 0 ? this.state.first : this.state.second;
        const candidate = selected.slice();
        candidate[index] = value;
        const variant = this.variant(candidate);
        let available;
        if (index === this.sizeIndex) {
          // A size remains reachable even if the currently chosen color is sold out.
          available = this.variants.some(v => String(v.options[index]) === String(value) && v.available);
        } else {
          const other = this.variant(piece === 0 ? this.state.second : this.state.first);
          available = this.canSupply(variant, duo && other && variant && String(other.id) === String(variant.id) ? 2 : 1);
        }
        button.disabled = this.busy || !available;
        button.setAttribute('aria-pressed', String(String(selected[index]) === String(value)));
        button.setAttribute('aria-label', `${piece === 0 ? 'Primer' : 'Segundo'} MAJESTUOSO: ${value}${available ? '' : ', no disponible para esta selección'}`);
      });
      [1, 2].forEach(quantity => {
        const nodes = this.offerNodes[quantity];
        const price = quantity === 1 ? prices.single : prices.duo;
        nodes.radio.checked = this.state.quantity === quantity;
        nodes.radio.disabled = this.busy;
        nodes.label.dataset.selected = String(this.state.quantity === quantity);
        nodes.price.textContent = price === null ? '—' : this.money(price);
      });
      const eligibleShipping = this.currency === 'CLP' && prices.duo !== null && prices.duo >= Number(this.config.freeShippingThreshold);
      this.offerNodes[2].benefit.textContent = [this.discountPercent ? '20% en la segunda' : '', eligibleShipping ? 'Envío gratis' : ''].filter(Boolean).join(' · ');
      this.offerNodes[2].benefit.hidden = !this.offerNodes[2].benefit.textContent;
      this.offerNodes[2].extra.textContent = prices.duo !== null && prices.single !== null ? `Por ${this.money(prices.duo - prices.single)} más` : 'Elige una combinación disponible';
      this.variantSelect.value = first ? String(first.id) : '';
      this.form.querySelector('[name="quantity"]').value = '1';
      this.sameSizeButton.disabled = this.busy;
      const error = this.selectionError();
      this.submitButton.disabled = this.busy || this.cartReviewRequired || !!error;
      this.submitButton.setAttribute('aria-disabled', String(this.submitButton.disabled));
      this.submitButton.setAttribute('aria-busy', String(this.busy));
      this.submitLabel.textContent = this.busy ? 'Agregando…' : this.cartRecoveryPending ? 'Revisando carrito…' : this.cartReviewRequired ? 'Revisa tu carrito' : error ? 'Elige una combinación disponible' : `Agregar ${duo ? '2 unidades' : '1 unidad'} · ${this.money(prices.total)}`;
      const freeShipping = this.currency === 'CLP' && prices.total !== null && prices.total >= Number(this.config.freeShippingThreshold);
      this.shippingNode.textContent = freeShipping ? 'Envío gratis a todo Chile.' : 'Envío calculado al pagar.';
      const section = document.getElementById(`MainProduct-${this.config.sectionId}`);
      const sticky = section && section.querySelector('[data-td-sticky-scroll-cta]');
      if (sticky) {
        const summary = sticky.querySelector('.td-sticky-atc__summary');
        const hint = sticky.querySelector('.td-sticky-atc__hint');
        const label = sticky.querySelector('.td-sticky-atc__button-label');
        const button = sticky.querySelector('[data-td-sticky-scroll-button]');
        if (summary) summary.textContent = prices.total === null ? 'MAJESTUOSO' : `${duo ? 'Dúo · 2 unidades' : '1 MAJESTUOSO'} · ${this.money(prices.total)}`;
        if (hint) hint.textContent = duo ? 'Revisa tus dos colores' : 'Revisa talla y color';
        if (label) label.textContent = 'Ver mi selección';
        if (button) button.setAttribute('aria-label', 'Volver a tu selección de MAJESTUOSO');
      }
      if (error && !this.busy && !this.cartReviewRequired) this.showError(error);
      if (announce) this.statusNode.textContent = error || `${duo ? '2 unidades' : '1 unidad'} · Total ${prices.total === null ? 'por confirmar' : this.money(prices.total)}.`;
    }

    updateURL(variant) {
      // Retain the test URL and all Intelligems / campaign query parameters.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    }

    updateMedia(variant) {
      if (!variant.mediaId) return;
      const section = document.getElementById(`MainProduct-${this.config.sectionId}`);
      if (!section) return;
      section.querySelectorAll('media-gallery').forEach(gallery => {
        if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(`${this.config.sectionId}-${variant.mediaId}`, false);
      });
    }

    cartURL() { return window.routes && window.routes.cart_url || `${window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'}cart`; }
    endpoint(action) { return `${window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'}cart${action ? `/${action}` : ''}.js`; }

    async getCart() {
      const response = await fetch(this.endpoint(''), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('No pudimos revisar el carrito. Inténtalo nuevamente.');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('No pudimos revisar el carrito. Inténtalo nuevamente.');
      return cart;
    }

    tokenLines(cart, token) { return cart.items.filter(line => line.properties && line.properties._td_md_request === token); }

    async rollback(cart, token) {
      // Automatic discounts can change line-item keys after each removal. Always
      // refresh the cart and resolve the next key again from our private token.
      let after = cart && Array.isArray(cart.items) ? cart : await this.getCart();
      let attempts = 0;
      while (this.tokenLines(after, token).length && attempts < 8) {
        const line = this.tokenLines(after, token)[0];
        attempts++;
        await fetch(this.endpoint('change'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
        after = await this.getCart();
      }
      if (this.tokenLines(after, token).length) throw new Error('Revisa tu carrito para comprobar las unidades agregadas.');
      this.clearPendingRequest(token);
      this.updateCartBubble(after);
      return after;
    }

    requireCartReview(message) {
      this.cartReviewRequired = true;
      this.cartReviewLink.hidden = false;
      this.showError(message);
    }

    pendingStorageKey() { return `td-md-pending-${PRODUCT_ID}`; }

    readPendingRequest() {
      try {
        const raw = window.sessionStorage && window.sessionStorage.getItem(this.pendingStorageKey());
        if (!raw) return null;
        const pending = JSON.parse(raw);
        if (!pending || typeof pending.token !== 'string' || !pending.token.startsWith('md-') || !Array.isArray(pending.items)) {
          window.sessionStorage.removeItem(this.pendingStorageKey());
          return null;
        }
        pending.items = pending.items.map(item => ({ id: String(item.id), quantity: Number(item.quantity) })).filter(item => item.id && item.quantity > 0);
        pending.quantity = Number(pending.quantity);
        if (pending.items.length && pending.quantity > 0) return pending;
        window.sessionStorage.removeItem(this.pendingStorageKey());
        return null;
      } catch (error) { return null; }
    }

    rememberPendingRequest(pending) {
      this.pendingRequest = pending;
      try {
        if (window.sessionStorage) window.sessionStorage.setItem(this.pendingStorageKey(), JSON.stringify(pending));
      } catch (error) { /* Instance state still protects this page. */ }
    }

    clearPendingRequest(token) {
      if (token && this.pendingRequest && this.pendingRequest.token !== token) return;
      this.pendingRequest = null;
      try {
        if (window.sessionStorage) window.sessionStorage.removeItem(this.pendingStorageKey());
      } catch (error) { /* Nothing else is required after authoritative verification. */ }
    }

    pendingIsComplete(lines, pending) {
      if (!pending || !Array.isArray(pending.items)) return false;
      return pending.items.every(item => lines.filter(line => String(line.variant_id || line.id) === String(item.id)).reduce((sum, line) => sum + Number(line.quantity), 0) === Number(item.quantity)) && lines.reduce((sum, line) => sum + Number(line.quantity), 0) === Number(pending.quantity);
    }

    onPageShow(event) {
      if (event.persisted && (this.cartReviewRequired || this.pendingRequest)) this.recoverAfterCartReview();
    }

    async recoverAfterCartReview() {
      const pending = this.pendingRequest || this.readPendingRequest();
      if ((!this.cartReviewRequired && !pending) || this.cartRecoveryPending) return;
      // Let an interrupted submit reach its finally block before reconciling.
      if (this.busy) {
        if (this.cartRecoveryTimer) window.clearTimeout(this.cartRecoveryTimer);
        this.cartRecoveryTimer = window.setTimeout(() => this.recoverAfterCartReview(), 150);
        return;
      }
      this.cartRecoveryPending = true;
      this.cartReviewRequired = true;
      this.cartReviewLink.hidden = false;
      this.render();
      try {
        let cart = await this.getCart();
        let message = 'Carrito actualizado. Puedes cambiar tu selección o agregar más unidades.';
        if (pending) {
          this.pendingRequest = pending;
          const lines = this.tokenLines(cart, pending.token);
          if (!lines.length) {
            message = 'La selección anterior no se agregó. Puedes intentarlo nuevamente.';
          } else if (this.pendingIsComplete(lines, pending)) {
            message = 'Tu selección anterior ya está en el carrito. Puedes cambiarla o agregar más unidades.';
          } else {
            cart = await this.rollback(cart, pending.token);
            message = 'Retiramos una selección incompleta. Puedes intentarlo nuevamente.';
          }
          this.clearPendingRequest(pending.token);
        }
        this.updateCartBubble(cart);
        this.cartReviewRequired = false;
        this.cartReviewLink.hidden = true;
        this.errorNode.textContent = '';
        this.errorNode.hidden = true;
        this.statusNode.textContent = message;
      } catch (error) {
        // Keep the safety lock if Shopify cannot provide an authoritative cart.
        this.requireCartReview('No pudimos actualizar el carrito. Revísalo antes de volver a agregar.');
      } finally {
        this.cartRecoveryPending = false;
        this.render();
      }
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.busy || this.cartReviewRequired) return;
      this.clearError();
      const selectionError = this.selectionError();
      if (selectionError) { this.showError(selectionError); return; }
      const quantity = this.state.quantity;
      const expected = this.prices().total;
      const token = `md-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
      const items = this.requestedItems().map(item => ({ ...item, properties: { _td_md_request: token, _td_md_offer: quantity === 2 ? 'duo' : 'individual', _td_md_test_product: PRODUCT_ID } }));
      let attempted = false;
      let knownResponse = false;
      let after = null;
      this.busy = true;
      this.statusNode.textContent = '';
      this.render();
      this.emit('submit-start');
      try {
        const before = await this.getCart();
        const stockError = this.selectionError(before);
        if (stockError) throw new Error(stockError);
        this.rememberPendingRequest({
          token,
          items: items.map(item => ({ id: String(item.id), quantity: Number(item.quantity) })),
          quantity,
          expected,
          beforeTotal: Number(before.total_price),
          startedAt: Date.now()
        });
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = this.cart && typeof this.cart.getSectionsToRender === 'function' ? this.cart.getSectionsToRender().map(section => section.id).slice(0, 5) : [];
        if (this.cart && typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(this.submitButton);
        const body = { items };
        if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
        attempted = true;
        const response = await fetch(this.endpoint('add'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        knownResponse = true;
        const result = await response.json();
        after = await this.getCart();
        if (!response.ok || result.status) {
          await this.rollback(after, token);
          attempted = false;
          throw new Error('No pudimos agregar la selección completa. Revisa la disponibilidad de talla y color e inténtalo otra vez.');
        }
        const added = this.tokenLines(after, token);
        const complete = items.every(item => added.filter(line => String(line.variant_id || line.id) === String(item.id)).reduce((sum, line) => sum + Number(line.quantity), 0) === item.quantity) && added.reduce((sum, line) => sum + Number(line.quantity), 0) === quantity;
        // Shopify can reassign an automatic discount to a pre-existing eligible
        // line. The authoritative amount for this action is therefore the change
        // in the whole cart total, not the final prices of only our new lines.
        const actual = Number(after.total_price) - Number(before.total_price);
        // One currency minor unit of tolerance covers percentage rounding.
        if (!complete || !Number.isFinite(actual) || actual > expected + (this.currency === 'CLP' ? 100 : 1)) {
          await this.rollback(after, token);
          attempted = false;
          throw new Error(!complete ? 'No pudimos agregar todas las unidades. Elige otra combinación e inténtalo nuevamente.' : 'No pudimos confirmar el precio de esta selección. No se agregó; revisa tu carrito o inténtalo más tarde.');
        }
        this.clearPendingRequest(token);
        attempted = false;
        this.statusNode.textContent = `${quantity === 2 ? 'Tus 2 MAJESTUOSOS están' : 'Tu MAJESTUOSO está'} en el carrito.`;
        this.emit('submit-success', { response: result });
        this.track('td_majestuoso_selection_added', { quantity, value: actual / 100, currency: this.currency });
        this.updateCartBubble(after);
        const usableSections = sections.length && result.sections && sections.every(id => typeof result.sections[id] === 'string');
        if (this.cart && usableSections && typeof this.cart.renderContents === 'function') {
          try {
            this.cart.classList.remove('is-empty');
            this.cart.renderContents({ ...result, key: result.key || result.items && result.items[0] && result.items[0].key });
          } catch (error) { window.location.assign(this.cartURL()); }
        } else window.location.assign(this.cartURL());
      } catch (error) {
        if (attempted) {
          if (knownResponse && after) {
            try { await this.rollback(after, token); this.showError('No se agregó esta selección. Inténtalo nuevamente.'); }
            catch (rollbackError) { this.requireCartReview('No pudimos confirmar todas las unidades. Revisa tu carrito antes de volver a agregar.'); }
          } else this.requireCartReview('No pudimos confirmar si se agregó tu selección. Revisa tu carrito antes de volver a agregar.');
        } else {
          this.clearPendingRequest(token);
          this.showError(error.message || 'No pudimos agregar tu selección. Inténtalo nuevamente.');
        }
        this.emit('submit-error', { message: this.errorNode.textContent });
      } finally {
        this.busy = false;
        this.render();
        this.emit('submit-end', { hasError: !this.errorNode.hidden });
      }
    }

    clearError() {
      if (this.cartReviewRequired) return;
      this.errorNode.textContent = '';
      this.errorNode.hidden = true;
      this.statusNode.textContent = '';
    }
    showError(message) { this.errorNode.textContent = message; this.errorNode.hidden = false; }

    emit(name, detail = {}) {
      document.dispatchEvent(new CustomEvent(`td:product-form:${name}`, { detail: { formId: this.form.id, ...detail } }));
    }
    track(event, detail) {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, product_id: PRODUCT_ID, ...detail });
    }
    updateCartBubble(cart) {
      const link = document.getElementById('cart-icon-bubble');
      if (!link) return;
      let bubble = link.querySelector('.cart-count-bubble');
      if (!cart.item_count) { if (bubble) bubble.remove(); return; }
      if (!bubble) {
        bubble = this.node('div', 'cart-count-bubble');
        const count = this.node('span'); count.setAttribute('aria-hidden', 'true');
        bubble.append(count, this.node('span', 'visually-hidden'));
        link.append(bubble);
      }
      const visible = bubble.querySelector('[aria-hidden="true"]');
      const accessible = bubble.querySelector('.visually-hidden');
      if (visible) visible.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
      if (accessible) accessible.textContent = `${cart.item_count} productos en el carrito`;
    }
  }
  customElements.define(TAG, MajestuosoDuo);
})();